module.exports = "https://www.gc-pro.gnp.com.mx/c3dcd8b95e236d62a782e873e13dbf64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-facebook.svg
// module id = 1826
// module chunks = 0